import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { addCartAttachment } from "../../redux/actions/cartAction";
import notify from "../useNotification";

const CartAttachmentHook = (item) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [showAttachmentModal, setShowAttachmentModal] = useState(false);
  const [attachmentImage, setAttachmentImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);

  const res = useSelector((state) => state.cartReducer.addCartAttachment);

  const handleShowAttachmentModal = () => setShowAttachmentModal(true);
  const handleCloseAttachmentModal = () => {
    setShowAttachmentModal(false);
    setAttachmentImage(null);
  };

  const handleAttachmentImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setAttachmentImage(e.target.files[0]);
    }
  };

  const handleAttachmentSubmit = async () => {
    if (!attachmentImage) {
      notify(t("please select an image"), "warn");
      return;
    }

    setLoading(true);
    setHasSubmitted(true);
    const formData = new FormData();
    formData.append("image", attachmentImage);
    await dispatch(addCartAttachment(item._id, formData));
    setLoading(false);
  };

  useEffect(() => {
    if (!hasSubmitted) return;
    if (loading === false) {
      if (res && res.status === 200) {
        notify(t("upload attachment"), "success");
        handleCloseAttachmentModal();
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else if (res && res.status !== 200) {
        notify(t("error in add attachment"), "error");
      }
    }
  }, [loading]);

  return [
    showAttachmentModal,
    handleShowAttachmentModal,
    handleCloseAttachmentModal,
    attachmentImage,
    handleAttachmentImageChange,
    handleAttachmentSubmit,
    loading,
  ];
};

export default CartAttachmentHook;
